export interface CreatedAtPropsHookArgs {
  date: string;
}

export interface CreatedAtPropsHook {
  timestamp: number;
}

export default function useCreatedAtProps({
  date,
}: CreatedAtPropsHookArgs): CreatedAtPropsHook {

  const timestamp = new Date(date).getTime();

  return {
    timestamp,
  };
}
